export class SessionExpirationError extends Error {
  constructor() {
    super('Session Expired');
    // tslint:disable-next-line max-line-length
    // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, SessionExpirationError.prototype);
  }
}
